import { render, staticRenderFns } from "./StatsCardV2.vue?vue&type=template&id=145f8f5d&"
import script from "./StatsCardV2.vue?vue&type=script&lang=js&"
export * from "./StatsCardV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports